import { tap } from 'rxjs/operators';

import { environment } from '../../../environments/environment';

/**
 * If `environment.production` is false, display stream events in a color-coded fashion
 * @param tag tag to identify stream
 */
export function debug<T>(tag: string) {
    return environment.production
        ? tap<T>()
        : tap<T>({
              next(value: any) {
                  console.log(
                      `%c[${tag}: Next]`,
                      'background: #009688; color: #fff; padding: 3px; font-size: 9px;',
                      value
                  );
              },
              error(error) {
                  console.log(
                      `%c[${tag}: Error]`,
                      'background: #E91E63; color: #fff; padding: 3px; font-size: 9px;',
                      error
                  );
              },
              complete() {
                  console.log(
                      `%c[${tag}]: Complete`,
                      'background: #00BCD4; color: #fff; padding: 3px; font-size: 9px;'
                  );
              }
          });
}
